import { createApiRef } from '@backstage/core-plugin-api';

/** @public */
export const HaclMapperMsgConversionApiRef =
  createApiRef<HaclMapperMsgConversionApi>({
    id: 'plugin.hacl-mapper-message-conversion.service',
  });

/** @public */
export interface HaclMapperMsgConversionApi {
  decodeHaclToJson(
    appliancePncElc: string,
    hacl: string,
  ): Promise<ComputedPatch>;
}

/** @public */
export interface ComputedPatch {
  stateUpdatePatchMap: Record<string, any>;
  telemetryUpdatePatchMap: Record<string, any>;
  telemetryHistoryUpdatePatchMap: Record<string, any>;
  diagnosticEventUpdatePatchMap: Record<string, any>;
}
